import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { ConnectedAccountCurrencyConversion } from './connected-account.currency-conversion.entity';
import { ConnectedAccountCurrencyConversionStatus } from './connected-account.currency-conversion.status.enum';

export class CreateConnectedAccountCurrencyConversionDto extends Omit(
    ConnectedAccountCurrencyConversion,
    [...BaseEntityFieldsArray, 'status', 'amount', 'convertedAmount', 'rate', 'providerRate'],
    ['status', 'amount', 'convertedAmount'],
) {
    status?: ConnectedAccountCurrencyConversionStatus;
    amount?: number;
    convertedAmount?: number;
}
